export enum ElementTypeEnum {
  BRUSH = 'BRUSH',
  LINE = 'LINE',
  RECT = 'RECT',
  ELLIPSE = 'ELLIPSE',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  SHAPE = 'SHAPE',
}
